module.exports = __webpack_public_path__ + "static/media/receipt_long.8d0354d6.svg";